// Ported from the mobile app's features/sky/shootingStarField.ts. One star per
// tenure week on a 52-week cycle, capped at 26. They fire at random moments in a
// window that grows with the count, so they arrive unevenly rather than at once.
import { hashSeed, mulberry32 } from "./random.js";

export function buildShootingStars(seed, weekCount, width, height) {
  const rng = mulberry32(hashSeed(`${seed}-shooting`));
  const count = weekCount > 0 ? Math.min(26, ((weekCount - 1) % 52) + 1) : 0;
  const spread = 2500 + count * 3000;
  return Array.from({ length: count }, () => ({
    delay: 500 + rng() * spread,
    startX: width * (0.05 + rng() * 0.9),
    startY: height * (0.04 + rng() * 0.55),
    dx: width * (0.5 + rng() * 0.25),
    dy: height * (0.02 + rng() * 0.05),
    length: Math.min(width, height) * (0.12 + rng() * 0.06),
  }));
}
